const MailIcon = ({
  width = 16,
  height = 16,
  fill = 'blue',
}: {
  width?: number
  height?: number
  fill?: string
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    style={{ marginRight: '4px', verticalAlign: 'middle' }}
  >
    <path
      d="M4 6H20C20.55 6 21 6.45 21 7V17C21 17.55 20.55 18 20 18H4C3.45 18 3 17.55 3 17V7C3 6.45 3.45 6 4 6Z"
      fill={fill}
      stroke='#1e73be'
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 7L12 13L21 7"
      fill={fill}
      stroke='#1e73be'
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MailIcon